export default __webpack_public_path__ + "static/media/vol1_2.a1af0c5e.png";